// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__28atp","large":"styles_large__L1KLZ"};